<template>
  <section class="home-widgets-container">
    <div class="container" v-if="hasWidgets">
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <div v-for="(widget, index) in widgets">
            <div class="row widget" v-if="index % 2 == 0">
              <hr class="separate">
              <div class="col-md-6">
                <h2 class="mt-4 subtitle subtitle_mobile ">{{widget.title}}</h2>
                <img :src="widget.image_url" />
              </div>
              <div class="col-md-6">
                <div class="subtitle_left">
                  <h2 class="mt-4 subtitle subtitle_desktop">{{widget.title}}</h2>
                  <p class="sub_text mt-4">{{widget.description}}</p>
                  <a :href="widget.link">
                    <button class="btn-widget">{{widget.link_text}}</button>
                  </a>
                </div>
              </div>
            </div>
            <div class="row widget" v-else>
              <hr class="separate">
              <div class="col-md-6">
                <div class="widget-right">
                  <h2 class="subtitle">{{widget.title}}</h2>
                  <img :src="widget.image_url" class="subtitle_mobile" />
                  <p class="sub_text mt-4 subtitle_desktop">{{widget.description}}</p>
                  <a :href="widget.link" class="subtitle_desktop">
                    <button class="btn-widget">{{widget.link_text}}</button>
                  </a>
                </div>
              </div>
              <div class="col-md-6">
                <img :src="widget.image_url" class="subtitle_desktop" />
                <p class="sub_text mt-4 subtitle_mobile">{{widget.description}}</p>
                <a :href="widget.link" class="subtitle_mobile">
                  <button class="btn-widget">{{widget.link_text}}</button>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2"></div>
      </div>
    </div>
  </section>
</template>

<script>
import WidgetList from "../../models/WidgetList"

export default {
  name: "WidgetsHome",
  data() {
    return {
      widgets: [],
      widgetList: new WidgetList()
    }
  },
  async created() {
    this.getWidgets()
  },
  methods:{
    async getWidgets() {
      const params = {scope: "Preference", lang: this.$i18n.locale}
      this.widgets = await this.widgetList.fetch(params)
    }
  },
  computed: {
    hasWidgets() {
      return this.widgets.length > 0
    }
  },
  watch: {
    "$i18n.locale"(val, oldVal) {
      this.getWidgets()
    }
  }
}
</script>

<style lang="scss">
  @import '../../scss/variables.scss';

  .home-widgets-container {
    .widget {
      margin-top: 30px;
      margin-bottom: 30px;

      img {
        width: 100%;
      }
    }
  }

  .btn-widget {
    margin-top: 20px;
    padding: 15px 10px 15px 10px;
    background: $primary-base;
    border: 1px solid $primary-base;
    color: $accent-base;
    border-radius: 25px;
    width: 100%;
  }

  .widget-right {
    text-align: center;
  }
</style>
